import type { FaireProductEntity } from "../../entity_types/product";

export const p_kk9u5fmpf9: FaireProductEntity = {
  token: "p_kk9u5fmpf9",
  type: "product",
  name: "18K Gold Plated Stainless Steel Water Droplet Earrings -FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/4558b77454d07401e40e5d2289fca9d37e368e84fd33de081ce0a628a746a398.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4b1c249aad99b058f94d3f5f5d94b91bac4d69208f2a99698d5d63cbf47c9484.jpeg",
    "https://cdn.faire.com/fastly/7333201ea91292599d76fcc539d22302e4512be53e9e780872f4b20973f6fe56.jpeg",
    "https://cdn.faire.com/fastly/07c260d6f7e1b9d0796c203db1e09f3e53d56cf8b0ec82963dff67ff47a83f1e.jpeg",
  ],
  priceDollars: 4.67,
  description:
    "Type: earrings\nMaterial : Stainless steel ，18K gold plated\nSize ： 7mm*31mm\nProcess: Vacuum electroplating and manual polishing\nSurface : High Polish\n★Made of high quality stainless steel，Lead-free，Harmless to Human Body.\n★Perfect jewelry gifts\n",
  tags: [],
  msrpDollars: 13.07,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:27:01.143Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
